import axios from 'axios';
import store from '../store'

const api = axios.create({
    baseURL: process.env.VUE_APP_URL_API_COMUNICADOS
});

const getAuthHeaders = token => ({
    Authorization: `Bearer ${token}`,
});

export default {
    async getImagenes(filters) {
        try {
            const response = await api.get('clients/compania/imagenes', {
                params: filters,
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async borrarImagen(id) {
        try {
            const response = await api.delete(`clients/compania/imagenes/${id}`, {
                headers: getAuthHeaders(store.getters.getTeatro.marketing_api_token),
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }
}